import { jsxs, jsx } from 'react/jsx-runtime';
import { createClient } from '@liveblocks/client';
import { createRoomContext } from '@liveblocks/react';
import { getWoodyClient } from '../../woody/woody.js';
import { useSocketIOParentRoom } from '../../socket.io/ParentRoom/SocketIOParentRoomContext.js';
import { useEffect } from 'react';
import { createLogger } from '@fabric-app/utils/logging';
import { useContextShareToken } from '../../permission/contexts/AnonShareTokenContext.js';

const getAccessTokenFromRoutePath = () => {
  const path = window.location.pathname;
  if (path.startsWith("/s/") || path.startsWith("/i/")) {
    return path.split("/")[2];
  }
  return void 0;
};
const liveblocksAuthEndpoint = async (roomIdentificator) => {
  const [rtype, roomId] = roomIdentificator.replace("-", ":::").split(":::");
  const roomType = rtype;
  const woodyClient = await getWoodyClient();
  return woodyClient.v2("/v2/liveblocks/authorization", {
    method: "post",
    body: {
      roomId,
      roomType
    },
    query: {
      accessToken: getAccessTokenFromRoutePath()
    }
  });
};
const client = createClient({
  authEndpoint: liveblocksAuthEndpoint
});
const roomContext = createRoomContext(client);
roomContext.RoomProvider;
const { useOthers: useFdocOthers, useSelf: useFdocSelf, useStatus: useFdocStatus, useUpdateMyPresence } = roomContext;
const logger = createLogger("Liveblocks/Resource item", true);
const defaultInitialPresence = {};
const ResourceRoomProvider = ({ children, initialPresence = defaultInitialPresence, resourceId, id, ...rest }) => {
  const parentRoomFabricSocket = useSocketIOParentRoom();
  const isWrappedWithFabricSocketContext = typeof parentRoomFabricSocket !== "undefined";
  useEffect(() => {
    if (!isWrappedWithFabricSocketContext) {
      console.warn("ResourceRoomProvider: parentRoomFabricSocket is not defined. Wrap this component with SocketIOParentRoomProvider");
      return;
    }
  }, [
    isWrappedWithFabricSocketContext
  ]);
  const shareToken = useContextShareToken();
  const shouldConnect = parentRoomFabricSocket && parentRoomFabricSocket?.connectedClients > 1 && shareToken?.type !== "publishing" || false;
  return /* @__PURE__ */ jsxs(roomContext.RoomProvider, {
    initialPresence,
    id: `resource-${resourceId}`,
    autoConnect: shouldConnect,
    ...rest,
    children: [
      children,
      /* @__PURE__ */ jsx(AutoConnector, {
        shouldConnect
      })
    ]
  });
};
const AutoConnector = ({ shouldConnect }) => {
  const room = roomContext.useRoom();
  const status = roomContext.useStatus();
  useEffect(() => {
    if (shouldConnect) {
      room.connect();
    } else {
      room.disconnect();
    }
  }, [
    shouldConnect,
    room
  ]);
  useEffect(() => {
    logger.log("status:", status);
  }, [
    status
  ]);
  return null;
};

export { ResourceRoomProvider, liveblocksAuthEndpoint, useFdocOthers, useFdocSelf, useFdocStatus, useUpdateMyPresence };
//# sourceMappingURL=fdocs.config.js.map
